/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Speed escalation levels for hold / speed-cycle trick-play.
 */
export enum SpeedLevel {
  L1 = 1,
  L2 = 2,
  L3 = 3
}
